const TAU = Math.PI * 2;
export const MAX_WHEEL_STEER = 0.62; // ~35°; also used to size wheelhouse clearance.

/** Rolling without slipping: angle = signed rendered distance / world radius.
 * Use displacement, rather than snapshot speed: when interpolation stops while
 * waiting for the next snapshot, the wheels must stop too. +X rotation rolls
 * toward the car's +Z front; reversing travel reverses rotation.
 */
export function advanceWheelSpin(angle, dx, dz, heading, radius) {
  const forward = dx * Math.sin(heading) + dz * Math.cos(heading);
  if (Math.abs(forward) < 1e-8) return angle;
  const distance = Math.hypot(dx, dz) * Math.sign(forward);
  return (angle + distance / radius) % TAU;
}
